import { MatDialogConfig } from '@angular/material/dialog';
import { DIALOG_MAX_WIDTH } from '@medicalapp/shared-core';

export const getDialogConfig = (config: MatDialogConfig) => {
  const dialogConfig = new MatDialogConfig();
  dialogConfig.disableClose = true;
  dialogConfig.autoFocus = false;
  dialogConfig.panelClass = ['primary-dialog'];
  dialogConfig.width = config?.width;
  dialogConfig.maxWidth = config?.maxWidth || DIALOG_MAX_WIDTH;
  dialogConfig.data = config?.data;
  return dialogConfig;
};
